"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteRewardTierResponseSchema = exports.updateRewardTierResponseSchema = exports.updateRewardTierBodySchema = exports.createRewardTierResponseSchema = exports.createRewardTierBodySchema = exports.listRewardTiersResponseSchema = exports.deleteRewardTierParamsSchema = exports.updateRewardTierParamsSchema = exports.createRewardTierParamsSchema = exports.listRewardTiersParamsSchema = exports.deleteCashierCodeResponseSchema = exports.createCashierCodeResponseSchema = exports.createCashierCodeBodySchema = exports.listCashierCodesResponseSchema = exports.deleteCashierCodeParamsSchema = exports.createCashierCodeParamsSchema = exports.listCashierCodesParamsSchema = exports.RewardTierEntitySchema = exports.CashierCodeEntitySchema = void 0;
const zod_1 = require("zod");
const common_schemas_1 = require("../base/common.schemas");
const api_schemas_1 = require("../base/api.schemas");
const timestamp_schemas_1 = require("../base/timestamp.schemas");
// ============================================
// INTERNAL SCHEMAS (Entity)
// ============================================
// Cashier code entity schema matching database cashier_codes table
const _CashierCodeBaseSchema = zod_1.z.object({
    code_id: zod_1.z.number().int().positive(),
    merchant_id: zod_1.z.number().int().positive(),
    user_id: common_schemas_1.uuidSchema, // Staff member
    code: zod_1.z.string().max(4), // bpchar(4) in DB
    is_active: zod_1.z.boolean(),
    created_at: timestamp_schemas_1.timestampIsoSchema,
});
// Reward tier entity schema matching database reward_tiers table
const _RewardTierBaseSchema = zod_1.z.object({
    tier_id: zod_1.z.number().int().positive(),
    merchant_id: zod_1.z.number().int().positive(),
    name: zod_1.z.string().max(100),
    min_deposit: common_schemas_1.moneyAmountSchema,
    bonus_percentage: common_schemas_1.basisPointsSchema.nullable(),
    bonus_coupon_id: zod_1.z.number().int().positive().nullable(),
    is_active: zod_1.z.boolean(),
    created_at: timestamp_schemas_1.timestampIsoSchema,
});
// ============================================
// ENTITY SCHEMAS (Export Aliases)
// ============================================
exports.CashierCodeEntitySchema = _CashierCodeBaseSchema;
exports.RewardTierEntitySchema = _RewardTierBaseSchema;
// ============================================
// MERCHANT SETTINGS API SCHEMAS
// ============================================
// Common merchant params schema
const _MerchantParamsSchema = zod_1.z.object({
    merchantId: zod_1.z.coerce.number().int().positive(),
});
// ============================================
// CASHIER CODES (FR185-189)
// ============================================
// Params schemas for cashier code endpoints
exports.listCashierCodesParamsSchema = _MerchantParamsSchema;
exports.createCashierCodeParamsSchema = _MerchantParamsSchema;
exports.deleteCashierCodeParamsSchema = _MerchantParamsSchema.extend({
    code: zod_1.z.string().length(4),
});
// Internal schema for cashier code item
const _CashierCodeItemSchema = zod_1.z.object({
    code: zod_1.z.string().length(4),
    cashier_name: zod_1.z.string(),
    created_at: timestamp_schemas_1.timestampIsoSchema,
});
// GET /merchants/:merchantId/settings/cashier-codes - Response
exports.listCashierCodesResponseSchema = (0, api_schemas_1.listResponseSchema)(_CashierCodeItemSchema);
// POST /merchants/:merchantId/settings/cashier-codes - Body (FR185-186)
exports.createCashierCodeBodySchema = zod_1.z.object({
    code: zod_1.z.string().length(4).regex(/^\d{4}$/), // 4-digit (FR186)
    cashier_name: zod_1.z.string().min(1).max(100),
});
// POST /merchants/:merchantId/settings/cashier-codes - Response
exports.createCashierCodeResponseSchema = (0, api_schemas_1.dataResponseSchema)(_CashierCodeItemSchema);
// DELETE /merchants/:merchantId/settings/cashier-codes/:code - Response
exports.deleteCashierCodeResponseSchema = api_schemas_1.messageResponseSchema;
// ============================================
// REWARD TIERS (FR204-210)
// ============================================
// Params schemas for reward tier endpoints
exports.listRewardTiersParamsSchema = _MerchantParamsSchema;
exports.createRewardTierParamsSchema = _MerchantParamsSchema;
exports.updateRewardTierParamsSchema = _MerchantParamsSchema.extend({
    tierId: zod_1.z.coerce.number().int().positive(),
});
exports.deleteRewardTierParamsSchema = _MerchantParamsSchema.extend({
    tierId: zod_1.z.coerce.number().int().positive(),
});
// Internal schema for reward tier item
const _RewardTierItemSchema = zod_1.z.object({
    tier_id: zod_1.z.number().int(),
    tier_name: zod_1.z.string(),
    minimum_amount: common_schemas_1.moneyAmountSchema.positive(), // FR205
    bonus_credit: common_schemas_1.moneyAmountSchema, // FR206
    reward_coupon_id: zod_1.z.number().int().nullable(), // FR73
    reward_coupon_quantity: zod_1.z.number().int().min(0), // FR73
    is_enabled: zod_1.z.boolean(), // FR208
    created_at: timestamp_schemas_1.timestampIsoSchema,
});
// GET /merchants/:merchantId/settings/reward-tiers - Response
exports.listRewardTiersResponseSchema = (0, api_schemas_1.listResponseSchema)(_RewardTierItemSchema);
// POST /merchants/:merchantId/settings/reward-tiers - Body (FR72-73, FR204-207)
exports.createRewardTierBodySchema = zod_1.z.object({
    tier_name: zod_1.z.string().min(1).max(100),
    minimum_amount: common_schemas_1.moneyAmountSchema.positive(),
    bonus_credit: common_schemas_1.moneyAmountSchema.default(0), // FR206
    reward_coupon_id: zod_1.z.number().int().positive().nullable(), // FR73
    reward_coupon_quantity: zod_1.z.number().int().min(0).default(0), // FR73
    is_enabled: zod_1.z.boolean().default(true), // FR208
});
// POST /merchants/:merchantId/settings/reward-tiers - Response
exports.createRewardTierResponseSchema = (0, api_schemas_1.dataResponseSchema)(_RewardTierItemSchema);
// PATCH /merchants/:merchantId/settings/reward-tiers/:tierId - Body
exports.updateRewardTierBodySchema = exports.createRewardTierBodySchema.partial();
// PATCH /merchants/:merchantId/settings/reward-tiers/:tierId - Response
exports.updateRewardTierResponseSchema = (0, api_schemas_1.dataResponseSchema)(_RewardTierItemSchema);
// DELETE /merchants/:merchantId/settings/reward-tiers/:tierId - Response
exports.deleteRewardTierResponseSchema = api_schemas_1.messageResponseSchema;
